import {Fragment} from 'react';

import {EmailingService as Service} from './EmailingService';

import {useToolbar} from '../../../shared/hooks/Toolbar';
import {useDataTable} from '../../../shared/hooks/DataTable';
import {useDialogCrup} from '../../../shared/hooks/DialogCrup';

export const List = () => {

  const header = 'Cấu hình email server';
  const dataKey = 'id';

  const {render: renderDataTable, refreshLazyData, reloadLazyData, selectedItems} = useDataTable({
    header,
    dataKey,
    columns: [
      {field: 'defaultFromDisplayName', header: 'Bí danh', minWidth: 160},
      {field: 'defaultFromAddress', header: 'Địa chỉ hiện thị', minWidth: 160},
      {field: 'useDefault', header: 'Sử dụng', width: 100, dataType: 'boolean'},
      {field: 'host', header: 'Máy chủ SMTP', matchMode: 'contains', minWidth: 160},
      {field: 'port', header: 'Cổng SMTP', width: 120},
      {field: 'enableSsl', header: 'Xác thực ssl', width: 110, dataType: 'boolean'},
      {field: 'useDefaultCredentials', header: 'Đăng nhập mặc định', width: 160, dataType: 'boolean'}
    ],
    actionColumnWidth: 0,
    getList: (params) => {
      return Service.getList(params);
    }
  });

  const {render: renderDialogCrup, create, update, clone} = useDialogCrup({
    header,
    dataKey,
    width: '80rem',
    fields: [
      {field: 'defaultFromDisplayName', header: 'Bí danh', InputTextProps: {maxLength: 250}, className: 'md:col-12'},
      // {field: 'domain', header: 'Domain', required: true, InputTextProps: {maxLength: 500}, className: 'md:col-6'},
      {field: 'defaultFromAddress', header: 'Địa chỉ hiện thị', required: true, InputTextProps: {maxLength: 500}, className: 'md:col-12'},
      {field: 'userName', header: 'Tài khoản', required: true, type: 'email', InputTextProps: {maxLength: 50}, className: 'md:col-6'},
      {field: 'password', header: 'Mật khẩu', type: 'Password', required: true, className: 'md:col-6'},
      {field: 'host', header: 'Máy chủ SMTP', required: true, InputTextProps: {maxLength: 50}, className: 'md:col-6'},
      {field: 'port', header: 'Cổng SMTP', required: true, InputTextProps: {maxLength: 5, keyfilter: 'int'}, className: 'md:col-6'},
      {field: 'enableSsl', header: 'Xác thực ssl', type: 'Checkbox', className: 'md:col-3'},
      {field: 'useDefault', header: 'Sử dụng', type: 'Checkbox', className: 'md:col-3'}
    ],
    createItem: (item) => {
      return Service.create(item);
    },
    updateItem: (id, item) => {
      return Service.update(id, item);
    },
    refreshLazyData
  });

  const {renderToolbar} = useToolbar({
    dataKey, create, update, clone, reloadLazyData, selectedItems,
    deleteItem: (id) => {
      return Service.delete(id);
    }
  });

  return (
    <Fragment>
      {renderToolbar()}
      {renderDataTable()}
      {renderDialogCrup()}
    </Fragment>
  )
}
